import { ScrollElements, } from "./global.types";
const initialScrollElements = Object.keys(ScrollElements).reduce((state, key) => ({ ...state, [key]: { isScroll: false } }), {});
const state = {
    isInited: false,
    isOffline: false,
    lastRequestedRoute: null,
    noConnectionDialogOpen: false,
    decisionTreeSelectedSteps: [],
    decisionTreeCurrentStep: null,
    decisionTreePreviousStep: null,
    decisionTreeModalOpened: false,
    decisionTreeLoading: false,
    renamingInProgress: false,
    rsEntityCreatingModalOpened: false,
    psTags: [],
    rsTags: [],
    KnownValueParameters: {},
    OptimisationParameters: {},
    AbsoluteTemplateParameters: {},
    RelativeTemplateParameters: {},
    Result0DParameters: {},
    ResultIndependentParameters: {},
    ResultDependentParameters: {},
    Bioreactors: [],
    MetricTemplates: {},
    bioreactorParameters: [],
    processVariables: [],
    parameterTypes: null,
    scrollElements: initialScrollElements,
    appVersions: null,
};
export default state;
